module.exports = __webpack_public_path__ + "img/Slice 14@2x.f8891f79.png";